import { readConfigHomeHomeHistory } from '@racepointenergy/swc/scs/read-config-home-home-history'
import { makeFetchSlice, fetchEdgeDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import {
  deleteDomainConfigFile,
  deployDomainConfigFile,
  DeployDomainConfigFileBody,
  fetchHomeActiveConfig,
  fetchHomeEnergyHistory,
  fetchHomeConfig,
  HomeActiveConfigParams,
  hostPasswordReset,
  hostPasswordChange,
  HostPasswordChangeParams,
} from 'features/home/api'
import {
  DELETE_DOMAIN_CONFIG_REDUCER_NAME,
  DEPLOY_DOMAIN_CONFIG_REDUCER_NAME,
  HOME_ACTIVE_CONFIG_REDUCER_NAME,
  HOME_ENERGY_HISTORY_REDUCER_NAME,
  HOME_CONFIG_REDUCER_NAME,
  HOST_PASSWORD_RESET_REDUCER_NAME,
  HOST_PASSWORD_CHANGE_REDUCER_NAME,
} from 'features/home/consts'
import { fetchHomeJobThunk } from '../HomeJobInfo/slice'

const homeActiveConfigSlice = makeFetchSlice(HOME_ACTIVE_CONFIG_REDUCER_NAME)
export const homeActiveConfigReducer = homeActiveConfigSlice.reducer
export const homeActiveConfigActions = homeActiveConfigSlice.actions

export const fetchHomeActiveConfigThunk = (
  homeId: string,
  params?: HomeActiveConfigParams
) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: homeActiveConfigActions,
        asyncFunc: () => fetchHomeActiveConfig(homeId, params),
      })
    } catch (error) {
      console.log('Error fetching home active config', error)
    }
  }
}

const homeEnergyHistorySlice = makeFetchSlice(HOME_ENERGY_HISTORY_REDUCER_NAME)
export const homeEnergyHistoryReducer = homeEnergyHistorySlice.reducer
export const homeEnergyHistoryActions = homeEnergyHistorySlice.actions

export const fetchHomeEnergyHistoryThunk = (
  homeId: string,
  bucket: string,
  startTime: string,
  endTime: string,
) => {
  return async (dispatch: AppDispatch) => {
    try {
      const body = {
        payload: {
          bucket: bucket,
          startTime: startTime,
          endTime: endTime
        }
      }
      await fetchEdgeDataThunk({
        dispatch,
        actions: homeEnergyHistoryActions,
        asyncFunc: () => fetchHomeEnergyHistory(homeId, body),
      })
    } catch (error) {
      console.log('Error fetching home energy history', error)
    }
  }
}

const homeConfigSlice = makeFetchSlice(HOME_CONFIG_REDUCER_NAME)
export const homeConfigReducer = homeConfigSlice.reducer
export const homeConfigActions = homeConfigSlice.actions

export const getHomeConfigThunk = (homeId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: homeConfigActions,
        asyncFunc: () => fetchHomeConfig(homeId),
      })
    } catch (error) {
      console.log('Error getting home config', homeId, error)
    }
  }
}

const deleteDomainConfigSlice = makeFetchSlice(
  DELETE_DOMAIN_CONFIG_REDUCER_NAME
)
export const deleteDomainConfigReducer = deleteDomainConfigSlice.reducer
export const deleteDomainConfigActions = deleteDomainConfigSlice.actions

export const deleteDomainConfigThunk = (configId: string, domainId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: deleteDomainConfigActions,
        asyncFunc: () => deleteDomainConfigFile(configId),
      })

      await dispatch(
        fetchHomeJobThunk(domainId, { configs: true, homes: true })
      )
    } catch (error) {
      console.log(`Error deleting domain config with id: ${configId}`, error)
    }
  }
}

const deployDomainConfigSlice = makeFetchSlice(
  DEPLOY_DOMAIN_CONFIG_REDUCER_NAME
)
export const deployDomainConfigReducer = deployDomainConfigSlice.reducer
export const deployDomainConfigActions = deployDomainConfigSlice.actions

export const deployDomainConfigThunk = (
  body: DeployDomainConfigFileBody,
  setPercentProgress: React.Dispatch<React.SetStateAction<number>>
) => {
  return async (dispatch: AppDispatch) => {
    await fetchEdgeDataThunk({
      dispatch,
      actions: deployDomainConfigActions,
      asyncFunc: () => deployDomainConfigFile(body, setPercentProgress),
    })
    const subscription = dispatch(
      readConfigHomeHomeHistory.initiate({ homeId: body.home_id })
    )
    subscription
      .unwrap()
      .catch(() => {
        /* noop */
      })
      .finally(() => {
        subscription.unsubscribe()
      })
  }
}



const hostPasswordChangeSlice = makeFetchSlice(HOST_PASSWORD_CHANGE_REDUCER_NAME)

export const hostPasswordChangeReducer = hostPasswordChangeSlice.reducer
export const hostPasswordChangeActions = hostPasswordChangeSlice.actions

export const hostPasswordChangeThunk = (params: HostPasswordChangeParams) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: hostPasswordResetActions,
        asyncFunc: () => hostPasswordChange(params),
      })
    } catch (error) {
      console.log('Error fetching hostPasswordChange for home', params.homeId, error)
      throw new Error('Network Error')
    }
  }
}

const hostPasswordResetSlice = makeFetchSlice(HOST_PASSWORD_RESET_REDUCER_NAME)

export const hostPasswordResetReducer = hostPasswordResetSlice.reducer
export const hostPasswordResetActions = hostPasswordResetSlice.actions

export const hostPasswordResetThunk = (params: HostPasswordChangeParams) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: hostPasswordResetActions,
        asyncFunc: () => hostPasswordReset(params),
      })
    } catch (error) {
      console.log('Error fetching hostPasswordReset for home', params.homeId, error)
      throw new Error('Network Error')
    }
  }
}
